const defaultOptions = require('./defaultOptions');
const getCreateFFmpegCore = require('./getCreateFFmpegCore');
const fetchFile = require('./fetchFile');

module.exports = {
  defaultOptions,
  getCreateFFmpegCore,
  fetchFile,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ffmpeg/ffmpeg/src/browser/index.js
// module id = Bem0
// module chunks = 5